import React, { useMemo } from "react";
import { AttributionProvider as SharedAttributionProvider, type AttributionRuntime } from "@orb-labs/orby-react";

/**
 * Web AttributionRuntime — no-op implementation. The web app does not track
 * deep-link / push attribution today, so shared screens reading via
 * useAttribution() always get organic.
 */
export function WebAttributionProvider({ children }: { children: React.ReactNode }) {
  const runtime = useMemo<AttributionRuntime>(
    () => ({
      getAttribution: () => ({ source: "organic" }),
      clearAttribution: () => {},
    }),
    []
  );
  return <SharedAttributionProvider runtime={runtime}>{children}</SharedAttributionProvider>;
}
